"use client";

import React from "react";

import { ChainIdProvider } from "@/entities/chain-id/context/provider";
import { StyledComponentsRegistryProvider } from "@/global/providers/styled-registry-provider";
import { Web3Provider } from "@/shared/contexts/web3-provider";
import { Navigation } from "@/widgets/navigation";

import { ThemeProvider } from "../providers/theme-provider";
import { useTheme } from "./use-theme";
interface Props {
  children: React.ReactNode;
}

export const LayoutClient: React.FC<Props> = ({ children }) => {
  const { changeTheme, selectableTheme, themeMode } = useTheme();

  return (
    <StyledComponentsRegistryProvider>
      <ThemeProvider mode={themeMode}>
        <Web3Provider>
          <ChainIdProvider>
            <Navigation
              onThemeChange={changeTheme}
              selectableTheme={selectableTheme}
            />
            {children}
          </ChainIdProvider>
        </Web3Provider>
      </ThemeProvider>
    </StyledComponentsRegistryProvider>
  );
};
